import { useTranslation } from "react-i18next";
import React, { useState, useEffect, useRef, useLayoutEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
// Icons
import {
  AiOutlineSearch,
} from "react-icons/ai";
import { MdOutlineWrongLocation } from "react-icons/md";

// Service
import { controlService } from "../../Services/control.service";
import { visitsService } from "../../Services/visits.service";
import { vehicleGroupService } from "../../Services/vehicle.group.service";

// Components
import RadiusCoordinatedMap from "../Components/Maps/RadiusCoordinatedMap";
import { ToastComponent } from "../Components/ToastComponent";
import { Filters } from "../../components/Filters";
import { useSelected } from "../../contexts/SelectedContext";
import EmptyData from "../../components/EmptyData";

// Libs
import { Button, Form, Modal } from "react-bootstrap";
import { Edit, GridComponent, Page, ColumnDirective, ColumnsDirective, Inject } from "@syncfusion/ej2-react-grids";
import { FaCarAlt, FaEdit, FaLink, FaMapMarkerAlt, FaTrash } from "react-icons/fa";
import { HiOutlineRectangleGroup } from "react-icons/hi2";
import { getLocationCoordinates } from "../../Services/locations.service";

const MARKER_TYPE_ID = 1; // Pontos de Controle


export default function ControlPoints() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const location = useLocation();
  const lat = location?.state?.lat;
  const lng = location?.state?.lng;

  useEffect(() => {
    dispatch({ type: "title", value: "Pontos de Controle" });
    fetchCoordinates();
    setActiveTab("grid");
    setIsViewMode(false);
    setIsEditing(false);
    setEditingItem(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [markerType, setMarkerType] = useState('end');
  const [markerName, setMarkerName] = useState('');
  const [radius, setRadius] = useState(50);
  const [address, setAddress] = useState('');
  const [latitude, setLatitude] = useState('');
  const [longitude, setLongitude] = useState('');
  
  const [coordinatesList, setCoordinatesList] = useState([]);
  const [selectedCoordinate, setSelectedCoordinate] = useState(null);
  const [pageSize, setPageSize] = useState(10);

  const [loading, setLoading] = useState(false);
  const [toastParams, setToastParams] = useState('');
  const [modalVisible, setModalVisible] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [addressOptions, setAddressOptions] = useState([]);
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [showModalEdit, setShowModalEdit] = useState(false);
  const [showModalControl, setShowModalControl] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [addressToDelete, setAddressToDelete] = useState(null);
  const [activeTab, setActiveTab] = useState("grid");
  const [, setIsViewMode] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [editingItem, setEditingItem] = useState(null);

  const [selectedBindMarker, setSelectedBindMarker] = useState(null);
  const [bindList, setBindList] = useState([]);
  const [vehicleGroups, setVehicleGroups] = useState([]);
  const [selectedVehicleIds, setSelectedVehicleIds] = useState([]);

  const gridRef = useRef(null);

  const { selectedValues } = useSelected();
  const selectedGroup = selectedValues.gruposModal?.[0] || 0;

  const fetchCoordinates = async () => {
    try {
      const response = await controlService.findCoordinate(MARKER_TYPE_ID);
      if (Array.isArray(response)) setCoordinatesList(response);
    } catch (error) {
      console.error("Erro ao buscar coordenadas:", error);
    } finally {
      setLoading(false);
    }
  };

  const reverseGeocode = async (lat, lng) => {
    try {
      if (!window.google || !window.google.maps) return null;
      const geocoder = new window.google.maps.Geocoder();
      return await new Promise((resolve) => {
        geocoder.geocode({ location: { lat: Number(lat), lng: Number(lng) } }, (results, status) => {
          if (status === window.google.maps.GeocoderStatus.OK && results?.length) {
            resolve(results[0]?.formatted_address || null);
          } else {
            resolve(null);
          }
        });
      });
    } catch (e) {
      return null;
    }
  };

  const handleView = async (selectAddress, overrideValues = {}) => {
    if (activeTab !== "map") {
      setActiveTab("map");
    }
    setLoading(true);

    const currentAddress = overrideValues.address !== undefined ? overrideValues.address : address;
    const currentLatitude = overrideValues.latitude !== undefined ? overrideValues.latitude : latitude;
    const currentLongitude = overrideValues.longitude !== undefined ? overrideValues.longitude : longitude;
    const currentMarkerName = overrideValues.markerName !== undefined ? overrideValues.markerName : markerName;

    var payload = {
      markerType,
      markerName: currentMarkerName,
      radius: radius || 50,
      address: currentAddress || "",
      latitude: currentLatitude || "",
      longitude: currentLongitude || "",
    };

    if (markerType == "end") {
      const searchAddress = (currentAddress && currentAddress.trim()) || selectAddress;
      if (!searchAddress || searchAddress.trim() === "") {
        setToastParams(
          JSON.stringify({
            show: true,
            title: "Atenção",
            body: "Informe um endereço para buscar.",
            color: "Warning",
          })
        );
        setLoading(false);
        return;
      }

      try {
        const response = await controlService.findAddress(searchAddress);

        if (response && response.latitude != null && response.longitude != null) {
          payload.latitude = Number(response.latitude);
          payload.longitude = Number(response.longitude);
          setSelectedCoordinate(payload);
        } else {
          setToastParams(
            JSON.stringify({
              show: true,
              title: "Atenção",
              body: "Coordenada para este endereço não encontrada, favor informe um endereço válido.",
              color: "Warning",
            })
          );
        }
      } catch (error) {
        console.error("Erro na busca de coordenadas:", error);
        setToastParams(
          JSON.stringify({
            show: true,
            title: "Erro",
            body: "Erro ao buscar endereço. Verifique sua conexão e tente novamente.",
            color: "Danger",
          })
        );
      } finally {
        setLoading(false);
      }
    }

    if (markerType == "coord") {
      if (!currentLatitude || !currentLongitude) {
        setToastParams(
          JSON.stringify({ show: true, title: "Atenção", body: "Informe latitude e longitude.", color: "Warning" })
        );
        setLoading(false);
        return;
      }
      setSelectedCoordinate({
        markerType,
        markerName: currentMarkerName,
        radius: radius || 50,
        address: currentAddress,
        latitude: Number(currentLatitude),
        longitude: Number(currentLongitude),
      });
      setLoading(false);
    }
  };

  const handleAddressSelect = (address) => {
    const selected = addressOptions.find((opt) => opt.location ?? opt.address === address);
    if (selected) {
      const payload = {
        markerType,
        markerName,
        radius: radius || 50,
        address: selected.address ?? selected.location,
        latitude: Number(selected.latitude),
        longitude: Number(selected.longitude),
      };
      setSelectedCoordinate(payload);
      setModalVisible(false);
    }
  };

  const handleInsert = async (overrideValues = {}) => {
    const currentMarkerName = overrideValues.markerName !== undefined ? overrideValues.markerName : markerName;
    const currentAddress = overrideValues.address !== undefined ? overrideValues.address : address;
    const currentLatitude = overrideValues.latitude !== undefined ? overrideValues.latitude : latitude;
    const currentLongitude = overrideValues.longitude !== undefined ? overrideValues.longitude : longitude;

    if (!currentMarkerName) {
      setToastParams(JSON.stringify({ show: true, title: "Atenção", body: "Informe um nome para o marcador.", color: 'Warning' }));
      return;
    }

    if (markerType == "coord" && (!currentLongitude || !currentLatitude)) {
      setToastParams(JSON.stringify({ show: true, title: "Atenção", body: "Informe as coordenadas, latitude e longitude.", color: 'Warning' }));
      return;
    }

    if (markerType == "end" && !currentAddress) {
      setToastParams(JSON.stringify({ show: true, title: "Atenção", body: "Informe as endereço.", color: 'Warning' }));
      return;
    }

    try {
      setLoading(true);

      const markerTypeId = MARKER_TYPE_ID;

      let latNum = null;
      let lngNum = null;
      let addressStr = currentAddress || "";

      if (markerType === "coord") {
        latNum = Number(currentLatitude);
        lngNum = Number(currentLongitude);
      } else {
        if (!selectedCoordinate || !selectedCoordinate.latitude || !selectedCoordinate.longitude) {
          setToastParams(
            JSON.stringify({ show: true, title: "Atenção", body: "Clique em Exibir e selecione o endereço primeiro.", color: 'Warning' })
          );
          setLoading(false);
          return;
        }
        latNum = Number(selectedCoordinate.latitude);
        lngNum = Number(selectedCoordinate.longitude);
        addressStr = selectedCoordinate.address || addressStr;
      }

      if (!addressStr && latNum != null && lngNum != null) {
        const resolved = await reverseGeocode(latNum, lngNum);
        if (resolved) {
          addressStr = resolved;
        } else {
          setToastParams(
            JSON.stringify({ show: true, title: "Atenção", body: "Endereço não informado e não foi possível obter pelo mapa.", color: 'Warning' })
          );
          setLoading(false);
          return;
        }
      }

      const payload = {
        markerTypeId,
        markerDescription: currentMarkerName,
        latitude: latNum,
        longitude: lngNum,
        address: addressStr,
        radius: Number(radius) || 50,
        area: "NA",
      };

      if (isEditing && editingItem) {
        payload.markerId = editingItem.markerId;
        payload.markerTypeId = editingItem.markerTypeId;

        const response = await controlService.updateCoordinate(payload);

        if (response && !response.error) {
          setToastParams(JSON.stringify({ show: true, title: "Sucesso", body: "Marcador atualizado.", color: 'success' }));
          setMarkerName("");
          setAddress("");
          setLatitude("");
          setLongitude("");
          setSelectedCoordinate(null);
          setIsEditing(false);
          setIsViewMode(false);
          setEditingItem(null);
          await fetchCoordinates();
          setActiveTab("grid");
        } else {
          const body = response?.message || response?.friendlyMessage || "Não foi possível atualizar o marcador.";
          setToastParams(JSON.stringify({ show: true, title: "Erro", body, color: 'Danger' }));
        }
      } else {
        const response = await visitsService.createMarker(payload);

        if (response && !response.error) {
          setToastParams(JSON.stringify({ show: true, title: "Sucesso", body: "Marcador criado.", color: 'success' }));
          setMarkerName("");
          setAddress("");
          setLatitude("");
          setLongitude("");
          setSelectedCoordinate(null);
          setIsEditing(false);
          setIsViewMode(false);
          setEditingItem(null);
          await fetchCoordinates();
          setActiveTab("grid");
        } else {
          const body = response?.message || response?.friendlyMessage || "Não foi possível criar o marcador.";
          setToastParams(JSON.stringify({ show: true, title: "Erro", body, color: 'Danger' }));
        }
      }

    } catch (error) {
      console.error("Erro ao salvar/criar marcador:", error);
      setToastParams(
        JSON.stringify({
          show: true,
          title: "Erro",
          body: error?.message || "Erro ao processar a operação. Tente novamente.",
          color: "Danger",
        })
      );
    } finally {
      setLoading(false);
    }

  };

  const handleEdit = (row) => {
    const coordinatePayload = {
      markerType: "coord",
      markerName: row.markerDescription,
      radius: Number(row.radius) || 50,
      address: row.address || row.location || "",
      latitude: Number(row.latitude),
      longitude: Number(row.longitude),
    };

    setMarkerName(row.markerDescription || "");
    setRadius(Number(row.radius) || 50);
    setAddress(row.address || row.location || "");
    setLatitude(String(row.latitude));
    setLongitude(String(row.longitude));
    setMarkerType("coord");

    setSelectedCoordinate(coordinatePayload);

    setIsViewMode(false);
    setIsEditing(true);
    setEditingItem(row);

    setActiveTab("map");
  };

  const openDeleteModal = (address) => {
    setAddressToDelete(address);
    setShowConfirmModal(true);
  };

  const confirmDelete = async () => {
    try {
      const response = await controlService.deleteAddress(
        addressToDelete.markerId,
        addressToDelete.markerTypeId
      );

      if (response?.data?.hasLinkedVehicles || response?.status === 409) {
        setToastParams(
          JSON.stringify({
            show: true,
            title: "Não permitido",
            body: "Existem veículos vinculados a este ponto. Desvincule para continuar.",
            color: "Warning",
          })
        );
        setShowConfirmModal(false);
        return;
      }

      if (response) {
        setToastParams(
          JSON.stringify({
            show: true,
            title: "Sucesso",
            body: "Endereço excluído com sucesso.",
            color: "Success",
          })
        );
        fetchCoordinates();
      } else {
        setToastParams(
          JSON.stringify({
            show: true,
            title: "Erro",
            body: "Não foi possível excluir o endereço.",
            color: "Danger",
          })
        );
      }
    } catch (error) {
      console.error("Erro ao excluir o endereço:", error);

      if (error?.response?.status === 409) {
        setToastParams(
          JSON.stringify({
            show: true,
            title: "Não permitido",
            body: "Este ponto possui veículos vinculados e não pode ser excluído.",
            color: "Warning",
          })
        );
      } else {
        setToastParams(
          JSON.stringify({
            show: true,
            title: "Erro",
            body: "Falha inesperada ao excluir.",
            color: "Danger",
          })
        );
      }
    } finally {
      setShowConfirmModal(false);
      setAddressToDelete(null);
    }
  };



  const handleSave = async () => {
    if (!selectedAddress) {
      setToastParams(
        JSON.stringify({
          show: true,
          title: "Atenção",
          body: "Nenhum endereço selecionado para atualizar.",
          color: "Warning",
        })
      );
      return;
    }

    setLoading(true);
    try {
      const payload = {
        markerId: selectedAddress.markerId,
        markerTypeId: selectedAddress.markerTypeId,
        markerDescription: selectedAddress.markerDescription,
        latitude: Number(selectedAddress.latitude),
        longitude: Number(selectedAddress.longitude),
        address: selectedAddress.address,
        radius: Number(selectedAddress.radius) || 50,
        area: selectedAddress.area || "NA",
      };
      const response = await controlService.updateCoordinate(payload);
      if (response && !response.error) {
        setToastParams(
          JSON.stringify({
            show: true,
            title: "Sucesso",
            body: "Endereço atualizado com sucesso.",
            color: "Success",
          })
        );
        setShowModalEdit(false);
        setSelectedCoordinate(null);
        await fetchCoordinates();
        setActiveTab("grid");
      } else {
        const body = response?.message || response?.friendlyMessage || "Não foi possível atualizar o endereço.";
        setToastParams(JSON.stringify({ show: true, title: "Erro", body, color: "Danger" }));
      }
    } catch (error) {
      console.error("Erro ao salvar as alterações:", error);
      setToastParams(
        JSON.stringify({
          show: true,
          title: "Erro",
          body: error?.message || "Erro ao atualizar o endereço. Tente novamente.",
          color: "Danger",
        })
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (lng && lat) {
      setLatitude(lat);
      setLongitude(lng);
      setMarkerType('coord');

      var coordinate = {
        latitude: lat,
        longitude: lng
      }

      setSelectedCoordinate(coordinate);
    }
    // eslint-disable-next-line
  }, [lng, lat]);
  /*
  const bindPointControls = async ({ listVehicleId }) => {
    if (!selectedBindMarker) {
      console.error("Nenhum marcador selecionado para vincular.");
      return;
    }

    setLoading(true);
    try {
      const payload = {
        listVehicleId,
        markerId: selectedBindMarker.markerId,
        markerTypeId: selectedBindMarker.markerTypeId,
      };

      const response = await controlService.bindPointControl(payload);

      if (response && !response.error) {
        setToastParams(
          JSON.stringify({
            show: true,
            title: "Sucesso",
            body: "Veículos vinculados ao ponto de passagem com sucesso.",
            color: "Success",
          })
        );

        setBindList((prev) =>
          prev.map((item) =>
            listVehicleId.includes(item.vehicleId)
              ? { ...item, markerStatusDescription: "Vinculado" }
              : item
          )
        );
      } else {
        const body =
          response?.message ||
          response?.friendlyMessage ||
          "Não foi possível vincular os veículos.";
        setToastParams(JSON.stringify({ show: true, title: "Erro", body, color: "Danger" }));
      }
    } catch (error) {
      console.error("Erro ao vincular veículos:", error);
      setToastParams(JSON.stringify({ show: true, title: "Erro", body: "Falha na requisição.", color: "Danger" }));
    } finally {
      setLoading(false);
    }
  };


  */

  /*
  const unbindPointControls = async ({ listVehicleId }) => {

    if (!selectedBindMarker) {
      console.error("Nenhum marcador selecionado para desvincular.");
      return;
    }

    setLoading(true);
    try {
      const payload = {
        listVehicleId,
        markerId: selectedBindMarker.markerId,
        markerTypeId: selectedBindMarker.markerTypeId,
      };

      const response = await controlService.unbindPointControl(payload);

      if (response && !response.error) {
        setToastParams(
          JSON.stringify({
            show: true,
            title: "Sucesso",
            body: "Veículos desvinculados do ponto de passagem com sucesso.",
            color: "Success",
          })
        );

        setBindList((prev) =>
          prev.map((item) =>
            listVehicleId.includes(item.vehicleId)
              ? { ...item, markerStatusDescription: "Pendente" }
              : item
          )
        );
      } else {
        const body =
          response?.message ||
          response?.friendlyMessage ||
          "Não foi possível desvincular os veículos.";
        setToastParams(JSON.stringify({ show: true, title: "Erro", body, color: "Danger" }));
      }
    } catch (error) {
      console.error("Erro ao desvincular veículos:", error);
      setToastParams(JSON.stringify({ show: true, title: "Erro", body: "Falha na requisição.", color: "Danger" }));
    } finally {
      setLoading(false);
    }
  };
  */


  const onBindCheckboxChange = (checked, vehicleId) => {
    if (checked) {
      setSelectedVehicleIds(prev =>
        prev.includes(vehicleId) ? prev : [...prev, vehicleId]
      );
    } else {
      setSelectedVehicleIds(prev => prev.filter(id => id !== vehicleId));
    }
  };

  const bindCheckboxTemplate = (props) => {
    const isChecked = selectedVehicleIds.includes(props.vehicleId);
    return (
      <input
        type="checkbox"
        checked={isChecked}
        onChange={(e) => onBindCheckboxChange(e.target.checked, props.vehicleId)}
      />
    );
  };

  const handleSaveBindings = async () => {
    if (!selectedBindMarker) {
      setToastParams(
        JSON.stringify({
          show: true,
          title: "Atenção",
          body: "Nenhum marcador selecionado.",
          color: "Warning",
        })
      );
      return;
    }

    setLoading(true);
    try {
      const markerTypeId = MARKER_TYPE_ID;

      const vehiclesToBind = selectedVehicleIds;
      const allVehicleIds = bindList.map(item => item.vehicleId);
      const vehiclesToUnbind = allVehicleIds.filter(id => !selectedVehicleIds.includes(id));

      const promises = [];

      const bindPayload = {
        listVehicleId: vehiclesToBind,
        markerId: selectedBindMarker.markerId,
        markerTypeId: markerTypeId,
      };
      promises.push(controlService.bindPointControl(bindPayload));

      if (vehiclesToUnbind.length > 0) {
        const unbindPayload = {
          listVehicleId: vehiclesToUnbind,
          markerId: selectedBindMarker.markerId,
          markerTypeId: markerTypeId,
        };
        promises.push(controlService.unbindPointControl(unbindPayload));
      }

      const responses = await Promise.all(promises);
      const hasError = responses.some(res => !res || res.error);

      if (!hasError) {
        const totalChanges = vehiclesToBind.length + vehiclesToUnbind.length;
        await controlService.updateMarkers();
        setToastParams(
          JSON.stringify({
            show: true,
            title: "Sucesso",
            body: `${totalChanges} alteração(ões) salva(s) com sucesso.`,
            color: "Success",
          })
        );

        setSelectedVehicleIds([]);
        setShowModalControl(false);
      } else {
        const body =
          responses.find(r => r?.message)?.message ||
          responses.find(r => r?.friendlyMessage)?.friendlyMessage ||
          "Não foi possível salvar as alterações.";
        setToastParams(JSON.stringify({ show: true, title: "Erro", body, color: "Danger" }));
      }
    } catch (error) {
      console.error("Erro ao salvar vinculações:", error);
      setToastParams(JSON.stringify({ show: true, title: "Erro", body: "Falha na requisição.", color: "Danger" }));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (showModalControl) {
      const fetchGroups = async () => {
        try {
          const groups = await vehicleGroupService.fetchGroups();
          setVehicleGroups(groups || []);
        } catch (error) {
          console.error("Erro ao buscar grupos:", error);
        }
      };
      fetchGroups();
    }
  }, [showModalControl]);

  useEffect(() => {
    if (!selectedBindMarker) return;

    const fetchBindsData = async () => {
      try {
        const vehicleGroupId = selectedGroup && selectedGroup !== "0" && selectedGroup !== "TODOS" ? selectedGroup : null;
        const markerTypeId = MARKER_TYPE_ID;
        const response = await controlService.fetchBindPointControl(
          markerTypeId,
          selectedBindMarker.markerId,
          vehicleGroupId
        );

        if (response) {
          setBindList(response);
          const alreadyLinked = response
            .filter(item => item.markerId && item.markerId > 0)
            .map(item => item.vehicleId);
          setSelectedVehicleIds(alreadyLinked);
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchBindsData();
  }, [selectedBindMarker, showModalControl, selectedGroup]);

  const calculatePageSize = () => {
    const windowHeight = window.innerHeight;

    let headerHeight = 60;
    let cardPadding = 30;
    let titleHeight = 50;
    let gridHeaderHeight = 35;
    let paginationHeight = 30;
    let rowHeight = 38;

    const totalFixedHeight =
      headerHeight +
      cardPadding +
      titleHeight +
      gridHeaderHeight +
      paginationHeight;

    const availableHeight = windowHeight - totalFixedHeight;

    const calculatedPageSize = Math.max(
      Math.floor(availableHeight / rowHeight),
      10
    );

    setPageSize(calculatedPageSize);
  };

  useLayoutEffect(() => {
    calculatePageSize();
  }, [location.pathname]);

  useEffect(() => {
    let timeoutId;
    const handleResize = () => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        calculatePageSize();
      }, 300);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
      clearTimeout(timeoutId);
    };
  }, []);

  const handleViewOnMap = (row) => {
    const coordinatePayload = {
      markerType: "coord",
      markerName: row.markerDescription,
      radius: Number(row.radius) || 50,
      address: row.address || row.location || "",
      latitude: Number(row.latitude),
      longitude: Number(row.longitude),
    };

    setMarkerName(row.markerDescription || "");
    setRadius(Number(row.radius) || 50);
    setAddress(row.address || row.location || "");
    setLatitude(String(row.latitude));
    setLongitude(String(row.longitude));
    setMarkerType("coord");

    setSelectedCoordinate(coordinatePayload);

    setIsViewMode(true);
    setIsEditing(false);
    setEditingItem(row);

    setActiveTab("map");
  };

  return (
    <>
      <Modal show={modalVisible} onHide={() => setModalVisible(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Selecione um endereço</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ul className="list-group">
            {addressOptions.map((opt, index) => (
              <li key={index} className="list-group-item" style={{ marginBottom: 20, borderTop: "1px solid #fff" }}>
                <Button
                  variant="link"
                  style={{ color: "var(--theme-primary)" }}
                  onClick={() => handleAddressSelect(opt.location ?? opt.address)}
                >
                  {opt.location ?? opt.address}
                </Button>
              </li>
            ))}
          </ul>
        </Modal.Body>
      </Modal>

      <Modal show={showModalEdit} onHide={() => setShowModalEdit(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Editar Coordenada</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {loading && <p>Processando...</p>}
          {selectedAddress && (
            <Form>
              <Form.Group className="mb-3">
                <Form.Label>Nome:</Form.Label>
                <Form.Control
                  type="text"
                  value={selectedAddress.markerDescription}
                  onChange={(e) =>
                    setSelectedAddress({ ...selectedAddress, markerDescription: e.target.value })
                  }
                  disabled={loading}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Raio (m):</Form.Label>
                <Form.Select
                  className="form-control"
                  value={Number(selectedAddress.radius) || 50}
                  onChange={(e) => setSelectedAddress({ ...selectedAddress, radius: Number(e.target.value) })}
                  disabled={loading}
                >
                  <option value="0">--Raio --</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                  <option value="200">200</option>
                  <option value="500">500</option>
                  <option value="1000">1000</option>
                </Form.Select>
              </Form.Group>
            </Form>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModalEdit(false)} disabled={loading}>
            Cancelar
          </Button>
          <Button variant="primary" onClick={handleSave} disabled={loading}>
            {loading ? "Salvando..." : t("BUTTONS.SAVE")}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showModalControl} onHide={() => setShowModalControl(false)} size="lg" scrollable>
        <Modal.Header
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "start",
            textAlign: "left",
          }}
        >
          <Modal.Title>Vincular veículo</Modal.Title>
          <p>Para que você possa excluir um ponto de passagem, ele não pode ter nenhum veículo vinculado</p>

          {/* Filtro de Grupos e Botões lado a lado */}
          <div style={{ display: "flex", gap: 16, alignItems: "flex-end", marginTop: 15, marginBottom: 10 }}>
            {/* Filtro de Grupos */}
            <div style={{ flex: 1 }}>
              <Filters
                id={"gruposModal"}
                isMulti={false}
                title={"Grupos"}
                hasSubTitle={true}
                subTitle={"Todos os grupos"}
                options={vehicleGroups || []}
                icon={HiOutlineRectangleGroup}
                hasIcon={true}
              />
            </div>

            {/* 🔹 Botões Selecionar/Desmarcar Todos */}
            <div style={{ display: "flex", gap: 8 }}>
              <Button
                variant="primary"
                onClick={() => {
                  const allIds = bindList.map((item) => item.vehicleId);
                  setSelectedVehicleIds(allIds);
                }}
              >
                Selecionar Todos
              </Button>

              <Button
                variant="secondary"
                onClick={() => {
                  setSelectedVehicleIds([]);
                }}
              >
                Remover Todos
              </Button>
            </div>
          </div>
        </Modal.Header>

        <Modal.Body>
          {loading && <p>Processando...</p>}
          {bindList.length === 0 ? (
            <p style={{ textAlign: "center", fontWeight: "500", padding: "20px 0" }}>
              Nenhum veículo encontrado para este ponto.
            </p>
          ) : (
            <GridComponent
              ref={gridRef}
              dataSource={bindList}
              allowPaging={false}
              cssClass="custom-grid-control"
              selectionSettings={{ type: "Multiple" }}
            >
              <ColumnsDirective>
                <ColumnDirective field="licensePlate" headerText={t("COMMON.PLATE")} width="10%" textAlign="Center" />
                <ColumnDirective
                  headerText="Vincular"
                  width="10%"
                  textAlign="Center"
                  template={bindCheckboxTemplate}
                />
                <ColumnDirective field="markerStatusDescription" headerText="Status" width="10%" textAlign="Center" />
              </ColumnsDirective>

              <Inject services={[Edit]} />
            </GridComponent>
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button variant="primary" onClick={handleSaveBindings} disabled={loading}>
            Salvar
          </Button>
          <Button variant="secondary" onClick={() => {
            setSelectedVehicleIds([]);
            setShowModalControl(false);
          }}>
            Fechar
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showConfirmModal} onHide={() => setShowConfirmModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Confirmar exclusão</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {addressToDelete && (
            <p>
              Deseja realmente excluir o endereço{" "}
              <strong>{addressToDelete.address}</strong>?
            </p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowConfirmModal(false)}>
            Cancelar
          </Button>
          <Button variant="danger" onClick={confirmDelete}>
            Excluir
          </Button>
        </Modal.Footer>
      </Modal>

      <div className='container-xxl flex-grow-1 container-p-y'>

        <ToastComponent params={toastParams} closeToast={() => setToastParams(JSON.stringify({ show: false }))} />

        <h5 className="subtitle-visits">Criar o marcador por:</h5>
        <div className="btn-group" role="group" aria-label="Basic radio toggle button group">

          <input type="radio" className="btn-check" name="btnradio" id="btnradio1" autoComplete="off" checked={markerType === "end"} onChange={(e) => setMarkerType('end')} />
          <label className="btn btn-outline-primary" htmlFor="btnradio1">Endereço</label>

          <input type="radio" className="btn-check" name="btnradio" id="btnradio3" autoComplete="off" checked={markerType === "coord"} onChange={(e) => setMarkerType('coord')} />
          <label className="btn btn-outline-primary" htmlFor="btnradio3">Cordenada</label>
        </div>

        <div className="row py-5" >

          <div className="col-3">
            <div className="input-group">
              <span className="input-group-text" id="markerName">Nome</span>
              <input type="text" className="form-control" aria-label="Name" placeholder="Marcador" value={markerName} aria-describedby="markerName" onChange={(e) => setMarkerName(e.target.value)} />
            </div>
          </div>

          <div className="col-2">
            <div className="input-group">
              <span className="input-group-text text-primary">
                Raio
              </span>
              <select
                name="vehicleGroup"
                className="form-control"
                defaultValue={radius}
                onChange={(e) => setRadius(e.target.value)}
              >
                <option value="0">--Raio --</option>
                <option value="50"> 50 </option>
                <option value="100"> 100 </option>
                <option value="200"> 200 </option>
                <option value="500"> 500 </option>
                <option value="1000"> 1000 </option>
              </select>
            </div>
          </div>

          <div className="col-4" style={markerType === 'coord' ? { display: 'none' } : {}}>
            <div className="input-group">
              <span className="input-group-text" id="address">Endereço</span>
              <input type="text" className="form-control" aria-label="Endereço" value={address} placeholder="Endereço" aria-describedby="address" onChange={(e) => setAddress(e.target.value)} />
            </div>
          </div>

          <div className="col-5" style={markerType === 'end' ? { display: 'none' } : {}}>
            <div className="row">
              <div className="col-6" >
                <div className="input-group">
                  <span className="input-group-text" id="lat">Latitude</span>
                  <input type="text" className="form-control" aria-label="latitude" placeholder="Ex: 11.54545" aria-describedby="lat" value={latitude} onChange={(e) => setLatitude(e.target.value)} />
                </div>
              </div>
              <div className="col-6" >
                <div className="input-group">
                  <span className="input-group-text" id="long">Longitude</span>
                  <input type="text" className="form-control" aria-label="Longitude" placeholder="Ex: -45.4532" aria-describedby="lat" value={longitude} onChange={(e) => setLongitude(e.target.value)} />
                </div>
              </div>
            </div>
          </div>

          <div className="col-2">
            <div className="row">
              <div className="col-6">
              

                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={async () => handleView()}
                  disabled={!((markerType === 'end' && address && Number(radius) > 0) || (markerType === 'coord' && latitude && longitude && Number(radius) > 0))}
                >
                  <AiOutlineSearch className="icon-in-button" />
                  Exibir
                </button>
              </div>
              <div className="col-6">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={async () => handleInsert()}
                  disabled={!((markerType === 'end' && address && Number(radius) > 0) || (markerType === 'coord' && latitude && longitude && Number(radius) > 0))}
                >
                  <MdOutlineWrongLocation className="icon-in-button" />
                  Inserir
                </button>
              </div>
            </div>

          </div>
        </div>

        {activeTab === "map" && (
          <RadiusCoordinatedMap coordinates={selectedCoordinate} mapLoading={loading} />
        )}

        {activeTab === "grid" && (
          <GridComponent
            dataSource={coordinatesList}
            allowPaging={true}
            pageSettings={{ pageSize }}
            emptyRecordTemplate={() => <EmptyData />}
          >
            <ColumnsDirective>
              <ColumnDirective
                headerText="Ponto de passagem"
                width="25%"
                textAlign="Left"
                template={(data) => (
                  <span>{data.markerDescription}</span>
                )}
              />
              <ColumnDirective
                headerText="Endereço"
                width="30%"
                textAlign="Left"
                template={(props) => {
                  return (
                    <a
                      href={`https://maps.google.com/?q=${getLocationCoordinates(
                        "location",
                        props
                      )}`}
                      target="_blank"
                      rel="noreferrer"
                      style={{
                        cursor: "pointer",
                        textDecoration: "underline",
                        color: "inherit",
                        fontSize: "10px",
                      }}
                    >
                      <div>{props.address ?? props.location}</div>
                    </a>
                  );
                }}
              />

              <ColumnDirective field="radius" headerText="Raio" width="10%" textAlign="Left" />

              <ColumnDirective
                headerText="Vincular / Desvincular"
                width="10%"
                textAlign="Center"
                template={(data) => (
                  <button
                    className="btn btn-link"
                    style={{ color: "var(--text-primary)" }}
                    onClick={() => {
                      setSelectedBindMarker({ ...data, markerTypeId: MARKER_TYPE_ID });
                      setShowModalControl(true);
                    }}
                  >
                    <FaLink size={20} />
                  </button>
                )}
              />

              <ColumnDirective
                headerText="Mapa"
                width="10%"
                textAlign="Center"
                template={(data) => (
                  <button
                    className="btn btn-link"
                    style={{ color: "#4285F4" }}
                    onClick={() =>
                      handleViewOnMap(data)
                    }
                  >
                    <FaMapMarkerAlt color="red" size={20} />
                  </button>
                )}
              />

              <ColumnDirective
                headerText="Editar"
                width="10%"
                textAlign="Center"
                template={(vehicle) => (
                  <button
                    className="btn btn-link"
                    style={{ color: "var(--text-primary)" }}
                    onClick={() => handleEdit(vehicle)}
                  >
                    <FaEdit size={18} />
                  </button>
                )}
              />

              <ColumnDirective
                headerText={t("BUTTONS.DELETE")}
                width="10%"
                textAlign="Center"
                template={(vehicle) => (
                  <button
                    className="btn btn-link"
                    data-delete-action="true"
                    aria-label="Excluir"
                    style={{ color: "var(--text-primary)" }}
                    onClick={() => openDeleteModal(vehicle)}
                  >
                    <FaTrash size={18} />
                  </button>
                )}
              />
            </ColumnsDirective>

            <Inject services={[Page]} />
          </GridComponent>
        )}
      </div>

      <div style={{
        display: 'flex',
        justifyContent: 'center',
        backgroundColor: 'rgba(255, 255, 255, 0.05)',
        borderRadius: '12px',
        padding: '4px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        maxWidth: '350px',
        margin: '0 auto 20px auto'
      }}>
        <button
          onClick={() => {
            setActiveTab("grid")
            setEditingItem(null)
            setIsEditing(false)
          }
          }
          style={{
            padding: '8px 20px',
            border: 'none',
            borderRadius: '8px',
            backgroundColor: activeTab === "grid" ? 'var(--theme-primary)' : 'transparent',
            color: activeTab === "grid" ? 'white' : '#6c757d',
            fontWeight: activeTab === "grid" ? '600' : '500',
            fontSize: '10px',
            cursor: 'pointer',
            transition: 'all 0.3s ease',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '6px',
            boxShadow: activeTab === "grid" ? '0 2px 8px rgba(108, 92, 231, 0.3)' : 'none',
            minWidth: '220px'
          }}
        >
          <FaCarAlt size={14} />
          Pontos de controle
        </button>

        <button
          onClick={() => {
            setIsViewMode(false);
            setIsEditing(false);
            setEditingItem(null);
            setSelectedCoordinate(null);
            if (!markerName && !address && !latitude && !longitude) {
              setMarkerType("end");
              setRadius(50);
            }
            setActiveTab("map");
          }}
          style={{
            padding: '8px 20px',
            border: 'none',
            borderRadius: '8px',
            backgroundColor: activeTab === "map" ? 'var(--theme-primary)' : 'transparent',
            color: activeTab === "map" ? 'white' : '#6c757d',
            fontWeight: activeTab === "map" ? '600' : '500',
            fontSize: '10px',
            cursor: 'pointer',
            transition: 'all 0.3s ease',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '6px',
            boxShadow: activeTab === "map" ? '0 2px 8px rgba(108, 92, 231, 0.3)' : 'none',
            minWidth: '120px'
          }}
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
          </svg>
          Mapa
        </button>
      </div>
    </>
  );

};
